<script setup>
import { ref, reactive, watch, computed } from 'vue'

const props = defineProps({
  isOpen: Boolean,
  itemData: { type: Object, default: null }
})

const emit = defineEmits(['close', 'save'])

const initialForm = {
  id: null,
  name: '',
  code: '',
  orderCodeOrTrackingNumbers: '',
  status: '1',
  fee: 0,
  manifest_id: null,
  weight: 0
}

const formData = reactive({ ...initialForm })

const isEdit = computed(() => !!props.itemData && !!props.itemData.id)

watch(() => props.isOpen, (newVal) => {
  if (newVal) {
    if (props.itemData) {
      Object.keys(initialForm).forEach(key => {
        formData[key] = props.itemData[key] !== undefined ? props.itemData[key] : initialForm[key];
      });
      // Nếu là mảng (từ API), chuyển thành chuỗi dấu phẩy để hiển thị trong input
      if (Array.isArray(formData.orderCodeOrTrackingNumbers)) {
        formData.orderCodeOrTrackingNumbers = formData.orderCodeOrTrackingNumbers.join('\n');
      }
    } else {
      Object.keys(initialForm).forEach(key => {
        formData[key] = initialForm[key];
      });
    }
    // Remove any extra keys from formData to keep it perfectly clean
    Object.keys(formData).forEach(key => {
      if (!(key in initialForm)) {
        delete formData[key];
      }
    });
  }
}, { immediate: true });

const closeForm = () => {
  emit('close')
}

const handleSubmit = () => {
  const submitData = { ...formData };
  
  if (!isEdit.value && typeof submitData.orderCodeOrTrackingNumbers === 'string') {
    submitData.orderCodeOrTrackingNumbers = submitData.orderCodeOrTrackingNumbers
      .split(/[,\n]/)
      .map(s => s.trim())
      .filter(s => s !== '');
  } else {
    // Nếu là edit, xóa luôn field này khỏi payload gửi đi
    delete submitData.orderCodeOrTrackingNumbers;
  }
  
  emit('save', submitData);
}
</script>

<template>
  <div v-if="isOpen" class="form-sidebar-overlay" @click.self="closeForm">
    <div class="form-sidebar">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h4>{{ isEdit ? 'Edit Parcel' : 'Add Parcel' }}</h4>
        <button class="btn-close" @click="closeForm"></button>
      </div>

      <form @submit.prevent="handleSubmit">
        <div class="mb-3">
          <label class="form-label">Name</label>
          <input type="text" class="form-control" v-model="formData.name" required>
        </div>
        <div class="mb-3">
          <label class="form-label">Code</label>
          <input type="text" class="form-control" v-model="formData.code" required>
        </div>
        <div v-if="!isEdit" class="mb-3">
          <label class="form-label">Order Code Or Tracking Numbers</label>
          <textarea 
            class="form-control" 
            v-model="formData.orderCodeOrTrackingNumbers" 
            rows="6" 
            placeholder="Mã đơn 1&#10;Mã đơn 2&#10;..."
          ></textarea>
        </div>
        <div class="mb-3">
          <label class="form-label">Fee</label>
          <input type="number" step="1" class="form-control" v-model.number="formData.fee">
        </div>
        <div class="mb-3">
          <label class="form-label">Weight</label>
          <input type="number" step="1" class="form-control" v-model.number="formData.weight">
        </div>
        <div class="mb-3">
          <label class="form-label">Status</label>
          <select class="form-select" v-model="formData.status">
            <option value="1">Active</option>
            <option value="2">Inactive</option>
            <option value="3">Pendding</option>
            <option value="4">Cancel</option>
          </select>
        </div>
        
        <div class="d-flex gap-2 mt-4">
          <button type="button" class="btn btn-secondary w-100" @click="closeForm">Cancel</button>
          <button type="submit" class="btn btn-primary w-100">
            {{ isEdit ? 'Update' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.form-sidebar-overlay {
  position: fixed;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4);
  z-index: 9999 !important;
}
.form-sidebar {
  position: fixed;
  top: 0; right: 0;
  width: 400px; height: 100%;
  background: white;
  padding: 30px;
  box-shadow: -5px 0 15px rgba(0,0,0,0.1);
  animation: slideIn 0.3s ease-out;
  overflow-y: auto;
}
@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}
</style>